import Button from "components/Button";
import Input from "components/Input";
import Modal, { ModalProps } from "components/Modal";
import React from "react";
import { useTranslation } from "react-i18next";
import { rulesSetStore } from "../RulesSetStore";
import { observer } from "mobx-react-lite";
import { RuleProps } from "./RuleRow";

interface RenameRulePopupProps extends ModalProps {
  rule: RuleProps | undefined;
}

const RenameRulePopup = (props: RenameRulePopupProps) => {
  const { t } = useTranslation();
  const [name, setName] = React.useState<string | undefined>();

  React.useEffect(() => {
    setName(props.rule?.name);
  }, [props.rule, props.open]);

  const onChangeValue = (value?: string) => setName(value);

  const onSaveName = () => {
    props.close();
    rulesSetStore.updateRule(props.rule, name);
  };

  return (
    <Modal
      isOpen={props.open}
      setIsOpen={props.close}
      title={t("rulesEditor.renameTheRule")}
      closeButton
      footer={
        <div className="flex items-center gap-4 border-t border-gray-100">
          <Button type="gray" onClick={props.close} width="fit-content">
            {t("commons.cancel")}
          </Button>
          <Button type="primary" onClick={onSaveName} width="fit-content">
            {t("rulesEditor.rename")}
          </Button>
        </div>
      }
      footerClassName="flex !justify-end"
      containerClassName="min-w-[640px]"
    >
      <div className="p-6">
        <Input value={name} onChange={onChangeValue} noMargin />
      </div>
    </Modal>
  );
};

export default observer(RenameRulePopup);
